export default __webpack_public_path__ + "static/media/photo 14.1372d670.jpg";